"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenericMapLine = void 0;
const theme_1 = require("../../../components/theme");
const mithril_1 = require("../../../mithril");
const CSS = {
    line: 'c-GenericMapLine',
};
const Style = {
    [CSS.line]: {
        position: 'absolute',
        strokeWidth: '2px',
        fill: 'none',
        pointerEvents: 'none',
    },
};
(0, theme_1.addStyles)(Style);
exports.GenericMapLine = {
    view({ key, start, end, color, strokeWidth = '2px', onClick, additionalClasses, additionalStyles, }) {
        const minX = Math.min(start.x, end.x);
        const minY = Math.min(start.y, end.y);
        const width = Math.abs(end.x - start.x);
        const height = Math.abs(end.y - start.y);
        return (0, mithril_1.m)('svg', {
            key,
            className: CSS.line,
            style: Object.assign({ left: `${minX}px`, top: `${minY}px`, width: `${width}px`, height: `${height}px` }, additionalStyles),
        }, [
            (0, mithril_1.m)('line', {
                x1: start.x - minX,
                y1: start.y - minY,
                x2: end.x - minX,
                y2: end.y - minY,
                stroke: color,
                'stroke-width': strokeWidth,
                onclick: onClick,
                style: {
                    pointerEvents: onClick ? 'auto' : 'none',
                    cursor: onClick ? 'pointer' : 'default',
                },
            }),
        ]);
    },
};
//# sourceMappingURL=map.line.generic.js.map